import React from "react";
import styled from "styled-components";
import { Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEgdHubCards } from "src/hooks/useEgdHubCards";
import TitleSection from "src/components/TitleSection/TitleSection";
import GameListCard from "src/components/ElectronicGamingDevices/GameListCard";
import Hero from "src/components/Hero/Hero";
import EventFinished from "src/components/EventFinished";

const ChineseNewYear2025Games = () => {
  const { i18n, t } = useTranslation();
  const { cards, loading, error } = useEgdHubCards("cny", i18n.language);

  return (
    <>
      <JackpotPage>
        <EventFinished eventType="promotion" />
        <Hero
          {...{
            bgImage: "promotions/cny-2025/1600x500_CNY_LP.png",
            image: `promotions/cny-2025/1600x800_CNY_Hero-Carousel_Logo_v3_${i18n.language}.png`,
            darkenBg: 0.5,
            overlayVideoSrc: "/videos/bbj-overlay.mp4",
          }}
        ></Hero>
        <container-wide>
          <TitleSection
            title={t("chineseNewYear2025.hero.title")}
            text={t("chineseNewYear2025.hero.text")}
          />
          {loading ? (
            <SpinnerHolder>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">{t("loading")}</span>
              </Spinner>
            </SpinnerHolder>
          ) : error ? (
            <div className="text-center text-danger">
              <p>
                {t("error.somethingWentWrong")}: {error}
              </p>
            </div>
          ) : (
            <Row className="g-4 gx-3" xs={1} md={2} lg={3}>
              {cards.map(({ game, jackpot }) => (
                <GameListCard
                  key={game.game_name}
                  game={game}
                  jackpot={jackpot || undefined}
                />
              ))}
            </Row>
          )}
          <Disclaimer className="text-center">
            *{t("egd.egdGameList.progressive_note_1")}
          </Disclaimer>
        </container-wide>
      </JackpotPage>
    </>
  );
};

const JackpotPage = styled.div`
  background-color: var(--black);
  .hero_text_container {
    display: none;
  }
  .title-section {
    p {
      padding: 0;
    }
  }
`;

const Disclaimer = styled.p`
  color: var(--mustard);
  font-size: 0.9rem;
  margin-top: 1rem;
`;

const SpinnerHolder = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px;
`;

export default ChineseNewYear2025Games;
